import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'
import { hotkey } from '#utilities/js/hotkey/hotkey.js'
import { elements } from '../../../styles.js'

const handler = object(null, {
  task (
    element,
    event
  ) {
    preventDefault(event)
    const exclusions = `${elements.button_toggle}`
    const { ownerDocument } = element
    const checkboxes = all('[type="checkbox"]', ownerDocument)

    for (const checkbox of checkboxes) {
      if (checkbox.classList.contains(exclusions)) {
        continue
      }

      globals.ea_list_selectline(checkbox, true)
    }
  }
})

export default (
  element
) => {
  hotkey(element, handler)
}
